import React from "react";
import propTypes from "prop-types";
import { cartBoxes } from "../helpers/cartBoxes";

const CartBox = (props) => {
  return (
    <div className="cart-box">
      {props.videos.length > 0 ? (
        <div>{cartBoxes(props.videos, props.removeFromCart)}</div>
      ) : (
        <p id="no-item-checkout" className="align-center">
          You don't have any items in your cart!
        </p>
      )}
    </div>
  );
};

CartBox.propTypes = {
  removeFromCart: propTypes.func,
  videos: propTypes.array,
};

export default CartBox;
